import { render, staticRenderFns } from "./newsletterComponent.vue?vue&type=template&id=1c149ccd&scoped=true"
import script from "./newsletterComponent.vue?vue&type=script&lang=js"
export * from "./newsletterComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c149ccd",
  null
  
)

export default component.exports